










































































































































import { Vue, Prop, Component, Watch } from "vue-property-decorator";
@Component
export default class extends Vue {
  @Prop() originStart!: string;
  @Prop() originEnd!: string;
  @Prop() showEndTime?: number;
  startTimeH: string = "00";
  startTimeM: string = "00";
  endTimeH: string = "00";
  endTimeM: string = "00";
  startDialogVisible: boolean = false;
  endDialogVisible: boolean = false;
  showDirection: string = "bottom";
  @Watch("originStart", { immediate: true, deep: true })
  onStartTime() {
    this.startTimeH = "00";
    this.startTimeM = "00";
  }
  @Watch("originEnd", { immediate: true, deep: true })
  onEndTime() {
    this.endTimeH = "00";
    this.endTimeM = "00";
  }
  init(start: string, end: string) {
    if (!start || !end) {
      return false;
    }
    start = start.slice(0, 5);
    end = end.slice(0, 5);
    this.startTimeH = start.split(":")[0];
    this.startTimeM = start.split(":")[1];
    this.endTimeH = end.split(":")[0];
    this.endTimeM = end.split(":")[1];
  }
  created() {
    this.init(this.originStart, this.originEnd);
  }
  showStartDialog(e: any) {
    const screenH = window.document.body.clientHeight;
    const clickY = e.pageY;
    if (screenH - clickY < 240) {
      this.showDirection = "top";
    } else {
      this.showDirection = "bottom";
    }
    this.startDialogVisible = true;
    this.$nextTick(() => {
      const h = 28 * Number(this.startTimeH);
      const m = (28 * Number(this.startTimeM)) / 5;
      (document.getElementById("start-h") as any).scrollTop = h;
      (document.getElementById("start-m") as any).scrollTop = m;
    });
    this.hideEndDialog();
  }
  hideStartDialog() {
    this.startDialogVisible = false;
    this.$emit("update:originStart", `${this.startTimeH}:${this.startTimeM}`);
    this.$emit("change");
  }
  showEndDialog(e: any) {
    const screenH = window.document.body.clientHeight;
    const clickY = e.pageY;
    if (screenH - clickY < 240) {
      this.showDirection = "top";
    } else {
      this.showDirection = "bottom";
    }
    this.endDialogVisible = true;
    this.$nextTick(() => {
      const h = 28 * Number(this.endTimeH);
      const m = (28 * Number(this.endTimeM)) / 5;
      (document.getElementById("end-h") as any).scrollTop = h;
      (document.getElementById("end-m") as any).scrollTop = m;
    });
    this.hideStartDialog();
  }
  hideEndDialog() {
    this.endDialogVisible = false;
    this.$emit("update:originEnd", `${this.endTimeH}:${this.endTimeM}`);
    this.$emit("change");
  }
  fixedNumber(n: number) {
    return 10 > n ? "0" + n : String(n);
  }
  hideAllDialog() {
    this.hideStartDialog();
    this.hideEndDialog();
    const Time = this.startTimeH + ":" + this.startTimeM;
  }
  // checkTime(type: string, n: number) {
  //   let a = Number(this.startTimeH);
  //   let b = Number(this.startTimeM);
  //   let c = Number(this.endTimeH);
  //   let d = Number(this.endTimeM);
  //   if (type === "sh") {
  //     a = n - 1;
  //   }
  //   if (type === "sm") {
  //     b = (n - 1) * 5;
  //   }
  //   if (type === "eh") {
  //     c = n - 1;
  //   }
  //   if (type === "em") {
  //     d = (n - 1) * 5;
  //   }
  //   if (a * 60 + b > c * 60 + d) {
  //     this.$message({
  //       message: "开始时间不可大于结束时间",
  //       type: "warning",
  //     });
  //     return false;
  //   }
  //   return true;
  // }
  sHselect(n: number) {
    this.startTimeH = this.fixedNumber(n - 1);
  }
  sMselect(n: number) {
    this.startTimeM = this.fixedNumber((n - 1) * 5);
  }
  eHselect(n: number) {
    this.endTimeH = this.fixedNumber(n - 1);
  }
  eMselect(n: number) {
    this.endTimeM = this.fixedNumber((n - 1) * 5);
  }
  @Watch("originStart", { immediate: false, deep: false })
  onOriginStartChange(n: string) {
    if (n) {
      this.init(n, this.originEnd);
    }
  }
  @Watch("originEnd", { immediate: false, deep: false })
  onOriginEndChange(n: string) {
    if (n) {
      this.init(this.originStart, n);
    }
  }
}
